var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-close',
                        view: publicPath + 'sprite.svg#view-icon-close',
                        viewBox: '0 0 40 40',
                        title: 'icons/fonctions/fermer',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };